import { useTranslation } from 'react-i18next';

export const CMS = () => {
  const { t } = useTranslation();

  return (
    <span
      role="img"
      aria-label={t('navigation.cms', 'CMS')}
      className="anticon  ant-menu-item-icon"
    >
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 12H6L9 5L13 19L16 12H22"
          stroke="currentColor"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};
